module.exports = __webpack_public_path__ + "static/media/system.f28b1eb0.svg";